import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  FormControl,
  FormLabel,
} from '@mui/material';
import {
  IntegracaoTerceiro,
  IntegracaoTerceiroPayload,
} from '../../../../../shared/services/api/c4-model/SistemasService';
import { ListaContainerSistema } from './components/containers-sistema/ListaContainerSistema';
import { EnumContainerTipo } from '../../../../../shared/enums';

type AcessoContainerPayload = {
  container: EnumContainerTipo;
  acao: string;
  meioAcesso: string;
};

type Props = {
  open: boolean;
  onClose: () => void;
  onSave?: (values: IntegracaoTerceiroPayload, editId?: string) => void;
  currentSystemId?: string;
  initialValues?: {
    id?: string;
    sistema?: string;
    descricao?: string;
    acessoContainers?: AcessoContainerPayload[];
  };
};

export const ModalIntegracaoTerceiros: React.FC<Props> = ({
  open,
  onClose,
  onSave,
  currentSystemId,
  initialValues,
}) => {
  const [sistema, setSistema] = useState('');
  const [descricao, setDescricao] = useState('');
  const [acessoContainers, setAcessoContainers] = useState<
    AcessoContainerPayload[]
  >([]);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    if (open) {
      if (initialValues) {
        setSistema(initialValues.sistema || '');
        setDescricao(initialValues.descricao || '');
        setAcessoContainers(initialValues.acessoContainers || []);
      } else {
        setSistema('');
        setDescricao('');
        setAcessoContainers([]);
      }
    }
  }, [open, initialValues]);

  useEffect(() => {
    const allFilled = Boolean(sistema.trim() && descricao.trim());
    setIsValid(allFilled);
  }, [sistema, descricao]);

  const handleSave = () => {
    const trimmedSistema = sistema.trim();
    const trimmedDescricao = descricao.trim();

    if (!trimmedSistema || !trimmedDescricao) {
      return;
    }

    const values: IntegracaoTerceiroPayload = {
      nomeSistema: trimmedSistema,
      sistemaIntegracaoId: currentSystemId,
      descricao: trimmedDescricao,
      acessoContainers: acessoContainers || [],
    };

    if (onSave) {
      onSave(values, initialValues?.id);
    }
  };

  const handleClose = () => {
    setSistema('');
    setDescricao('');
    setAcessoContainers([]);
    onClose();
  };

  return (
    <Dialog open={!!open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle>
        {initialValues?.id
          ? 'Editar Integração Terceiros'
          : 'Nova Integração Terceiros'}
      </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection="column" gap={3}>
          <FormControl>
            <FormLabel required>Sistema</FormLabel>
            <TextField
              fullWidth
              variant="outlined"
              value={sistema}
              onChange={(e) => setSistema(e.target.value)}
              placeholder="Ex: Sistema de Terceiros"
            />
          </FormControl>

          <FormControl>
            <FormLabel required>Descrição</FormLabel>
            <TextField
              fullWidth
              variant="outlined"
              multiline
              rows={3}
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
              placeholder="Ex: Integração para consulta de dados de clientes"
            />
          </FormControl>

          <Box>
            <FormLabel>Containers que os acessam</FormLabel>
            <ListaContainerSistema
              initialRows={acessoContainers}
              onContainersChange={setAcessoContainers}
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={handleSave}
          color="primary"
          disabled={!isValid}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
